import { render } from "./show-more.vue?vue&type=template&id=7bf34885"
import script from "./show-more.vue?vue&type=script&lang=js"
export * from "./show-more.vue?vue&type=script&lang=js"

import "./show-more.vue?vue&type=style&index=0&id=7bf34885&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__